import React from 'react';
import { NGRP_LOGO_URL_XS } from '@/lib/config';

export function TricolourRibbon({ className = '' }) {
  return <div className={`tricolour-ribbon ${className}`} aria-hidden="true" />;
}

export function SectionKicker({ children, className = '' }) {
  return (
    <div
      className={`text-xs sm:text-sm font-medium uppercase tracking-[0.14em] text-[#062B5C] ${className}`}
    >
      {children}
    </div>
  );
}

export function SectionHeading({ eyebrow, title, subtitle, align = 'left' }) {
  const alignCls = align === 'center' ? 'text-center mx-auto' : 'text-left';
  return (
    <div className={`max-w-3xl ${alignCls}`}>
      {eyebrow && <SectionKicker>{eyebrow}</SectionKicker>}
      <h2 className="font-display mt-3 text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-[-0.01em] text-[#0B1220]">{title}</h2>
      {subtitle && (
        <p className="mt-4 text-[15px] sm:text-base text-[#5B6B82] leading-relaxed">{subtitle}</p>
      )}
    </div>
  );
}

export function Container({ children, className = '' }) {
  return (
    <div className={`max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 ${className}`}>{children}</div>
  );
}

export function NGRPLogoMark({ size = 40, className = '' }) {
  return (
    <img
      src={NGRP_LOGO_URL_XS}
      alt="NGRP Logo"
      width={size}
      height={size}
      loading="eager"
      decoding="async"
      style={{ width: size, height: size }}
      className={`rounded-full object-contain border border-[#D7E1EF] bg-white ${className}`}
    />
  );
}
